export const systemConfigsMessages = {
  ratingSystem: 'Hệ thống đánh giá',
  callCenterSystem: 'Hệ thống tổng đài',
  ratingSystemApiUrl: 'API URL',
  ratingSystemApiKey: 'API key',
  noValue: 'Chưa có',
  updateRatingSystem: 'Cập nhật hệ thống đánh giá',
  callCenterSystemHost: 'Host',
  callCenterSystemApiUrl: 'API URL',
  callCenterSystemDescription: 'Mô tả',
  callCenterSystemApiList: 'Danh sách API',
  connectCallCenterSystem: 'Kết nối hệ thống tổng đài',
  integrateFanPage: 'Tích hợp fanpage',
  fanPageApiUrl: 'API URL',
  fanPageDescription: 'Mô tả',
  gatewayApiName: 'Tên API',
  gatewayApiPath: 'Đường dẫn',
  gatewayApiDescription: 'Mô tả',
  settingAiAgent: 'Thiết lập AI Agent',
  maximumAIAgentForCall: 'Số lượng AI xử lý cuộc gọi tối đa',
  useAIAgentForCall: 'Số lượng AI xử lý cuộc gọi sử dụng',
  maximumAIAgentForChat: 'Số lượng AI xử lý cuộc chat tối đa',
  useAIAgentForChat: 'Số lượng AI xử lý cuộc chat sử dụng',
  updateAIAgentSuccess: 'Cập nhật thiết lập AI Agent thành công'
};
